<template>
  <section>
    <b-loading :is-full-page="false" :active.sync="isLoading" :canCancel="false"></b-loading>
    <h1 class="section-head">เพิ่มผลิตภัณฑ์</h1>
    <div class="field is-horizontal">
      <router-link class="button is-danger is-pulled-left" :to="backPage"><i class="fas fa-arrow-left"></i>Back</router-link>
    </div>
    <div class="column is-8">
      <div class="field is-horizontal">
        <div class="field-label is-normal">
          <label class="label">ซัพพลายเออร์</label>
        </div>
        <div class="field-body">
          <div class="field has-addons">
            <b-field
            :type="alert.supplier.type"
            :message="alert.supplier.msg">
              <b-select placeholder="โปรดเลือกซัพพลายเออร์" v-model="item.sup_id" :disabled="(this.$route.params.supId)||item.id ? false:false">
                  <option
                      v-for="supplier in supplierList"
                      :value="supplier.id"
                      :key="supplier.id">
                      {{ supplier.name }}
                  </option>
              </b-select>
            </b-field>

          </div>
        </div>
      </div>

      <div class="field is-horizontal">
        <div class="field-label is-normal">
          <label class="label">ชื่อผลิตภัณฑ์</label>
        </div>
        <div class="field-body">
          <div class="field">
            <p class="control">
              <input class="input " type="text" placeholder="ชื่อผลิตภัณฑ์" v-model="item.name">
            </p>
          </div>
        </div>
      </div>

      <div class="field is-horizontal">
        <div class="field-label is-normal">
          <label class="label">ราคาซื้อ</label>
        </div>
        <div class="field-body">
          <div class="field has-addons">
            <p class="control">
              <input class="input" type="text" placeholder="ราคาซื้อ" v-model="item.price_buy">
            </p>
            <p class="control">
              <a class="button is-static">
                บาท ต่อ
              </a>
            </p>
            <div class="select">
              <select v-model="item.unit_buy">
                <option value="">โปรดเลือกหน่วยซื้อ</option>
                <option v-for="(unit, key) in unitList" :key="key" :value="key">{{unit}}</option>
              </select>
            </div>
          </div>
        </div>
      </div>

      <div class="field is-horizontal">
        <div class="field-label is-normal">
          <label class="label">ราคา PestGaurd</label>
        </div>

        <div class="field-body">
          <div class="field has-addons">
            <p class="control">
              <input class="input" type="text" placeholder="ราคาขาย" v-model="item.price_sell">
            </p>
            <p class="control">
              <a class="button is-static">
                บาท ต่อ
              </a>
            </p>
            <div class="select">
              <select v-model="item.unit_sell">
                <option value="">โปรดเลือกหน่วยขาย</option>
                <option v-for="(unit, key) in unitList" :key="key" :value="key">{{unit}}</option>
              </select>
            </div>
          </div>
        </div>

      </div>


      <div class="field is-horizontal">
        <div class="field-label is-normal">
          <label class="label">ราคาลูกค้าทั่วไป</label>
        </div>

        <div class="field-body">
          <div class="field has-addons">
            <p class="control">
              <input class="input" type="text" placeholder="ราคาขาย" v-model="item.general_price_sell">
            </p>
            <p class="control">
              <a class="button is-static">
                บาท ต่อ
              </a>
            </p>
            <div class="select">
              <select v-model="item.unit_sell">
                <option value="">โปรดเลือกหน่วยขาย</option>
                <option v-for="(unit, key) in unitList" :key="key" :value="key">{{unit}}</option>
              </select>
            </div>
          </div>
        </div>

      </div>

      <div class="field is-horizontal">
        <div class="field-label is-normal">
          <label class="label">ตัวคูณ</label>
        </div>
        <div class="field-body">
          <div class="field has-addons">
            <p class="control">
              <input class="input" type="text" placeholder="ตัวคูณ" v-model="item.multiply">
            </p>
          </div>
        </div>
      </div>


      <div class="field is-horizontal">
        <div class="field-label is-normal">
          <label class="label">Re-Order Point</label>
        </div>
        <div class="field-body">
          <div class="field has-addons">
            <p class="control">
              <input class="input" type="text" placeholder="Re-Order Point" v-model="item.reorder">
            </p>
            <p class="control">
              <a class="button is-static">
                {{ Const.product_unit[item.unit_sell] }}
              </a>
            </p>
          </div>
        </div>
      </div>


      <div class="field is-horizontal">
        <div class="field-label">
          <!-- Left empty for spacing -->
        </div>
        <div class="field-body">
          <div class="field is-grouped">
            <p class="control">
              <a class="button is-primary" :class="loadingClass" @click="submit">
                บันทึก
              </a>
            </p>
            <p class="control">
              <router-link class="button is-light" :to="backPage">ยกเลิก</router-link>
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  import Request from '@/libraries/request';
  import ProductModel from '@/model/product_model';
  import SupplierModel from '@/model/supplier_model';
  import Const from '@/const/const';
  
  export default {
    data() {
      return {
        Const: Const,
        item: {
          name: '',
          price_buy: '',
          unit_buy: '',
          price_sell: '',
          general_price_sell: '',
          unit_sell: '',
          reorder: 0,
          multiply: 1,
          sup_id: this.$route.params.supId ? this.$route.params.supId : 0,
        },
        unitList: Const.product_unit,
        supplierList: {},
        supId: this.$route.params.supId ? this.$route.params.supId : 0,
        supplier: '',
        isLoading: false,
        backPage:  this.$route.params.supId ? "/supplier/view/"+this.$route.params.supId : "/product",
        loadingClass: "",
        alert: {
          supplier: {
            type: '',
            msg: ''
          }
        }
      }
    },
    mounted() {
      // console.log(this.$route.params.supId);
      // console.log(this.$route.params.proId);
      this.init();
    },
    methods: {
      async init() {
        this.isLoading = true;
        if(this.$route.params.proId){
          this.item = await ProductModel.get_product(this.$route.params.proId);
          this.supId = this.item.sup_id;
          this.backPage = "/supplier/view/"+this.supId;
        }
        if(this.supId != 0){
          this.supplier = await SupplierModel.get_supplier(this.supId);
        }
        this.supplierList  = await SupplierModel.get_all_supplier();
        this.isLoading = false;
      },
      submit() {
        this.loadingClass = "is-loading";
        if(!this.item.sup_id){
          this.alert.supplier.type = "is-danger";
          this.alert.supplier.msg = "กรุณาระบุซัพพลายเออร์";
          this.loadingClass = "";
          return false;
        }
        this.isLoading = true;
        
        Request.post('product/add',this.item,(res) => {
          this.isLoading = false;
          this.loadingClass = "";
          if(res.data.status){
            if(res.data.data.sup_id){
              this.$router.push({ path: '/supplier/view/'+res.data.data.sup_id })
            }else{
              this.$router.push({ path: '/product/view/'+res.data.id })
            }
          }
        });
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/pages/Product/add.vue